/**
 * Dropdown function
 */
const DropdownMenu = () => {
  const dropdownItems = document.querySelectorAll('[data-dropdown-item]');

  Array.prototype.slice.call(dropdownItems).forEach((item) => {
    item.querySelector('span').addEventListener('click', () => {
      item.querySelector('span').classList.toggle('is-open');
      item.querySelector('[data-dropdown-menu]').classList.toggle('is-visible');
    });
  });
};

export default DropdownMenu;
